import { startCaseFileUpload } from '@/backend/case'
import type { StartCaseFileUpload } from '@/backend/caseTypes'
import type { Eventually } from '@/data/clientUtils'
import { invariant } from '@/shared/utils/typeAssertions'
import { useMutation, type UseMutationOptions } from '@tanstack/vue-query'
import { toValue } from 'vue'

type MutationReturn = StartCaseFileUpload['successResponse']

type MutationParams = {
  caseId: string
  filename: string
}

/** Initiate a case file upload, giving us a signed URL to which we can upload the file. */
export const useStartCaseFileUpload = (
  workspaceId: Eventually<string>,
  options: UseMutationOptions<MutationReturn, Error, MutationParams, unknown> = {},
) => {
  return useMutation({
    mutationFn: async ({ caseId, filename }: MutationParams) => {
      const wid = toValue(workspaceId)
      invariant(wid)
      const res = await startCaseFileUpload(wid, caseId, filename)
      if (!res.ok) {
        throw new Error(res.error.code)
      }

      return res.data
    },
    ...options,
  })
}
